import { render, staticRenderFns } from "./TrainingRegistration_4.vue?vue&type=template&id=6c5c93d3&"
import script from "./TrainingRegistration_4.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistration_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports